var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"password-reset"}},[_c('Form',{attrs:{"header":_vm.header,"model":_vm.model,"schema":_vm.schema,"options":_vm.options,"buttons":_vm.buttons,"messages":_vm.messages},on:{"form_submit":_vm.form_submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }